import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiCallService } from 'src/app/core/services/api-call-service';
import { TranslateDynamicText } from 'src/app/shared/pipes/dynamic-translation.pipe';
import { SnackbarCollection } from "src/app/core/services/snackbar.service";

@Component({
  selector: 'app-static-footer',
  templateUrl: './static-footer.component.html',
  styleUrls: ['../../pages/static-page/static-page.component.css', './static-footer.component.css']
})
export class StaticFooterComponent implements OnInit {
  year;
  newsLetterForm: FormGroup;
  invalidEmail= false;
  apiLoading = false;
  errorMessage = "";
  successMessage = "";
  alreadySubscribed = false;
  subscibeSuccess = false;
  disableInput = false;
  contactForm: FormGroup;
  socialMediaLinks = [
    
    {
      id: 1,
      tag: "linkedin",
      link: "https://www.linkedin.com/company/qubriux",
      svg: `<svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.1" fill-rule="evenodd" clip-rule="evenodd" d="M1 21.74C1 9.73333 10.7333 0 22.74 0C34.7467 0 44.48 9.73333 44.48 21.74C44.48 33.7467 34.7467 43.48 22.74 43.48C10.7333 43.48 1 33.7467 1 21.74Z" fill="white"/>
<path d="M32.35 23.3372V30.1796C32.35 30.2198 32.342 30.2597 32.3266 30.2968C32.3111 30.334 32.2886 30.3678 32.2601 30.3962C32.2316 30.4246 32.1977 30.4471 32.1605 30.4624C32.1233 30.4777 32.0834 30.4855 32.0432 30.4854H28.5109C28.4298 30.4854 28.352 30.4532 28.2947 30.3958C28.2373 30.3385 28.2051 30.2607 28.2051 30.1796V23.8161C28.2051 22.1418 27.6069 20.9984 26.1057 20.9984C25.6385 21.0011 25.1835 21.1482 24.803 21.4195C24.4226 21.6909 24.1353 22.0731 23.9804 22.514C23.8738 22.8395 23.8272 23.1816 23.8429 23.5238V30.1796C23.8429 30.2607 23.8107 30.3385 23.7533 30.3958C23.696 30.4532 23.6182 30.4854 23.5371 30.4854H20.0058C19.9656 30.4855 19.9258 30.4777 19.8886 30.4624C19.8514 30.4471 19.8177 30.4245 19.7893 30.3961C19.7609 30.3677 19.7383 30.3339 19.723 30.2968C19.7077 30.2596 19.6999 30.2198 19.7 30.1796C19.7077 28.4851 19.7433 20.2627 19.7077 18.3307C19.707 18.2902 19.7145 18.2499 19.7296 18.2123C19.7447 18.1747 19.7671 18.1405 19.7956 18.1116C19.824 18.0828 19.858 18.06 19.8954 18.0444C19.9328 18.0288 19.973 18.0209 20.0135 18.021H23.538C23.6192 18.0213 23.697 18.0537 23.7543 18.1112C23.8117 18.1687 23.8439 18.2466 23.8439 18.3278V19.7876C23.8362 19.8021 23.8237 19.8155 23.816 19.829H23.8439V19.7876C24.2189 19.1359 24.7654 18.5994 25.4239 18.2365C26.0824 17.8735 26.8278 17.6979 27.5791 17.7287C30.3054 17.7287 32.35 19.5097 32.35 23.3372ZM13.5693 30.4854H17.1006C17.1817 30.4854 17.2595 30.4532 17.3168 30.3958C17.3742 30.3385 17.4064 30.2607 17.4064 30.1796V18.3297C17.4064 18.2485 17.3742 18.1706 17.3169 18.1131C17.2595 18.0556 17.1818 18.0232 17.1006 18.023H13.5693C13.4881 18.0232 13.4102 18.0556 13.3529 18.1131C13.2956 18.1706 13.2634 18.2485 13.2634 18.3297V30.1825C13.2642 30.2631 13.2968 30.3401 13.354 30.3969C13.4113 30.4536 13.4887 30.4854 13.5693 30.4854Z" fill="white"/>
<path d="M15.2186 16.4372C16.4439 16.4372 17.4372 15.4439 17.4372 14.2186C17.4372 12.9933 16.4439 12 15.2186 12C13.9933 12 13 12.9933 13 14.2186C13 15.4439 13.9933 16.4372 15.2186 16.4372Z" fill="white"/>
</svg>
`
    },
    {
      id: 2,
      tag: "facebook",
      link: "https://www.facebook.com/Qubriux/",
      svg: `<svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.1" fill-rule="evenodd" clip-rule="evenodd" d="M1.00523 21.4862C1.00523 9.48184 10.7367 -0.249634 22.7411 -0.249634C34.7455 -0.249634 44.4769 9.48184 44.4769 21.4862C44.4769 33.4906 34.7455 43.2221 22.7411 43.2221C10.7367 43.2221 1.00523 33.4906 1.00523 21.4862Z" fill="white"/>
<path d="M23.9316 22.5927H27.4212L27.969 19.0262H23.9309V17.077C23.9309 15.5954 24.4121 14.2816 25.7896 14.2816H28.0031V11.1692C27.6142 11.1164 26.7917 11.0007 25.2375 11.0007C21.992 11.0007 20.0894 12.7251 20.0894 16.6536V19.0262H16.7531V22.5927H20.0894V32.3954C20.7501 32.4954 21.4193 32.5632 22.1063 32.5632C22.7273 32.5632 23.3334 32.5061 23.9316 32.4247V22.5927Z" fill="white"/>
</svg>
`
    },
    {
      id: 3,
      tag: "twitter",
      link: "https://twitter.com/Qubriux",
      svg: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.1" fill-rule="evenodd" clip-rule="evenodd" d="M0.174774 21.767C0.174774 9.76098 9.90756 0.0281982 21.9136 0.0281982C33.9195 0.0281982 43.6523 9.76098 43.6523 21.767C43.6523 33.773 33.9195 43.5058 21.9136 43.5058C9.90756 43.5058 0.174774 33.773 0.174774 21.767Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2625 17.6977L21.3081 18.4499L20.5478 18.3578C17.7803 18.0047 15.3626 16.8073 13.3098 14.7963L12.3062 13.7985L12.0477 14.5353C11.5003 16.1779 11.8501 17.9126 12.9905 19.0793C13.5987 19.7241 13.4619 19.8162 12.4127 19.4324C12.0477 19.3096 11.7284 19.2175 11.698 19.2635C11.5916 19.371 11.9565 20.7679 12.2454 21.3206C12.6408 22.0881 13.4467 22.8404 14.3286 23.2855L15.0737 23.6386L14.1918 23.654C13.3402 23.654 13.3098 23.6693 13.4011 23.9917C13.7052 24.9895 14.9064 26.0488 16.2446 26.5093L17.1873 26.8317L16.3662 27.3229C15.1497 28.0291 13.7204 28.4282 12.291 28.4589C11.6068 28.4743 11.0442 28.5357 11.0442 28.5817C11.0442 28.7352 12.8993 29.5949 13.9789 29.9326C17.2177 30.9305 21.0648 30.5006 23.9539 28.7966C26.0067 27.5839 28.0595 25.1737 29.0174 22.8404C29.5344 21.5969 30.0514 19.3249 30.0514 18.235C30.0514 17.5288 30.0971 17.4367 30.9486 16.5924C31.4504 16.1012 31.9218 15.5639 32.013 15.4104C32.1651 15.1187 32.1498 15.1187 31.3743 15.3797C30.0819 15.8402 29.8994 15.7788 30.538 15.088C31.0094 14.5967 31.572 13.7064 31.572 13.4454C31.572 13.3993 31.3439 13.4761 31.0854 13.6143C30.8117 13.7678 30.2035 13.998 29.7473 14.1362L28.9262 14.3972L28.1811 13.8906C27.7706 13.6143 27.1927 13.3072 26.8886 13.2151C26.1131 13.0002 24.9271 13.0309 24.2276 13.2765C22.3269 13.9673 21.1256 15.7481 21.2625 17.6977Z" fill="white"/>
</svg>
`
    },
    {
      id: 4,
      tag: "instagram",
      link: "https://instagram.com/qubriux",
      svg: `<svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.1" fill-rule="evenodd" clip-rule="evenodd" d="M0.753815 21.767C0.753815 9.76098 10.4866 0.0281982 22.4926 0.0281982C34.4986 0.0281982 44.2314 9.76098 44.2314 21.767C44.2314 33.773 34.4986 43.5058 22.4926 43.5058C10.4866 43.5058 0.753815 33.773 0.753815 21.767Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.4937 10.173C19.3449 10.173 18.9497 10.1867 17.713 10.243C16.4787 10.2995 15.6362 10.495 14.899 10.7817C14.1365 11.0778 13.4896 11.4739 12.8452 12.1186C12.2003 12.7631 11.8041 13.4099 11.507 14.1722C11.2196 14.9097 11.0239 15.7524 10.9684 16.9862C10.9131 18.2229 10.8986 18.6183 10.8986 21.7671C10.8986 24.9159 10.9126 25.3098 10.9686 26.5465C11.0254 27.7808 11.2208 28.6233 11.5073 29.3605C11.8036 30.1231 12.1998 30.77 12.8445 31.4144C13.4887 32.0593 14.1355 32.4564 14.8976 32.7526C15.6353 33.0393 16.478 33.2347 17.7121 33.2912C18.9488 33.3475 19.3437 33.3612 22.4922 33.3612C25.6412 33.3612 26.0352 33.3475 27.2719 33.2912C28.5062 33.2347 29.3497 33.0393 30.0874 32.7526C30.8497 32.4564 31.4956 32.0593 32.1398 31.4144C32.7847 30.77 33.1808 30.1231 33.4779 29.3608C33.7629 28.6233 33.9586 27.7806 34.0166 26.5468C34.0721 25.3101 34.0866 24.9159 34.0866 21.7671C34.0866 18.6183 34.0721 18.2232 34.0166 16.9865C33.9586 15.7522 33.7629 14.9097 33.4779 14.1725C33.1808 13.4099 32.7847 12.7631 32.1398 12.1186C31.4948 11.4737 30.8499 11.0776 30.0866 10.7817C29.3475 10.495 28.5045 10.2995 27.2702 10.243C26.0335 10.1867 25.6398 10.173 22.4901 10.173H22.4937ZM21.4535 12.2623C21.7622 12.2618 22.1067 12.2623 22.4936 12.2623C25.5893 12.2623 25.9562 12.2734 27.1786 12.329C28.3091 12.3807 28.9226 12.5695 29.3313 12.7282C29.8723 12.9384 30.2581 13.1896 30.6636 13.5954C31.0694 14.0012 31.3206 14.3877 31.5313 14.9287C31.6899 15.3369 31.8791 15.9504 31.9305 17.0809C31.9861 18.3031 31.9982 18.6702 31.9982 21.7644C31.9982 24.8586 31.9861 25.2258 31.9305 26.448C31.8788 27.5784 31.6899 28.1919 31.5313 28.6001C31.3211 29.1412 31.0694 29.5265 30.6636 29.932C30.2578 30.3378 29.8726 30.589 29.3313 30.7991C28.9231 30.9586 28.3091 31.147 27.1786 31.1987C25.9564 31.2542 25.5893 31.2663 22.4936 31.2663C19.3978 31.2663 19.0308 31.2542 17.8086 31.1987C16.6782 31.1465 16.0647 30.9576 15.6557 30.7989C15.1147 30.5888 14.7282 30.3376 14.3224 29.9318C13.9166 29.526 13.6654 29.1405 13.4548 28.5992C13.2961 28.191 13.107 27.5774 13.0555 26.447C13 25.2248 12.9889 24.8576 12.9889 21.7615C12.9889 18.6654 13 18.3002 13.0555 17.078C13.1072 15.9475 13.2961 15.334 13.4548 14.9253C13.6649 14.3843 13.9166 13.9978 14.3224 13.592C14.7282 13.1862 15.1147 12.935 15.6557 12.7244C16.0644 12.565 16.6782 12.3766 17.8086 12.3246C18.8782 12.2763 19.2927 12.2618 21.4535 12.2594V12.2623ZM28.6825 14.1874C27.9144 14.1874 27.2912 14.8099 27.2912 15.5782C27.2912 16.3463 27.9144 16.9695 28.6825 16.9695C29.4506 16.9695 30.0738 16.3463 30.0738 15.5782C30.0738 14.8101 29.4506 14.1874 28.6825 14.1874ZM22.4937 15.813C19.2056 15.813 16.5396 18.4789 16.5396 21.7671C16.5396 25.0552 19.2056 27.7199 22.4937 27.7199C25.7818 27.7199 28.4468 25.0552 28.4468 21.7671C28.4468 18.4789 25.7818 15.813 22.4937 15.813ZM22.4937 17.9024C24.6279 17.9024 26.3584 19.6325 26.3584 21.7671C26.3584 23.9014 24.6279 25.6318 22.4937 25.6318C20.3591 25.6318 18.6289 23.9014 18.6289 21.7671C18.6289 19.6325 20.3591 17.9024 22.4937 17.9024Z" fill="white"/>
</svg>
`
    },
    {
      id: 5,
      tag: "youtube",
      link: "https://www.youtube.com/@Qubriux",
      svg: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.1" fill-rule="evenodd" clip-rule="evenodd" d="M0.388184 21.7694C0.388184 9.76342 10.121 0.0306396 22.127 0.0306396C34.133 0.0306396 43.8657 9.76342 43.8657 21.7694C43.8657 33.7754 34.133 43.5082 22.127 43.5082C10.121 43.5082 0.388184 33.7754 0.388184 21.7694Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M31.1862 14.2963C32.184 14.5701 32.9697 15.3768 33.2364 16.4012C33.721 18.2579 33.721 22.1319 33.721 22.1319C33.721 22.1319 33.721 26.0058 33.2364 27.8626C32.9697 28.887 32.184 29.6937 31.1862 29.9677C29.3781 30.4651 22.127 30.4651 22.127 30.4651C22.127 30.4651 14.8758 30.4651 13.0676 29.9677C12.0698 29.6937 11.2841 28.887 11.0174 27.8626C10.533 26.0058 10.533 22.1319 10.533 22.1319C10.533 22.1319 10.533 18.2579 11.0174 16.4012C11.2841 15.3768 12.0698 14.5701 13.0676 14.2963C14.8758 13.7987 22.127 13.7987 22.127 13.7987C22.127 13.7987 29.3781 13.7987 31.1862 14.2963ZM19.9531 18.871V26.1173L25.7501 22.4943L19.9531 18.871Z" fill="white"/>
</svg>
`
    },
  ]

  constructor(private router: Router, 
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private apiCall: ApiCallService,
    private snackbar: SnackbarCollection,
    private _i18nDynamicTranslate: TranslateDynamicText) { }

  getCurrentYear() {
    const today = new Date();
    let currentYear = today.getFullYear();
    this.year = currentYear;
  }

  // formControl(){
  //   this.newsLetterForm = this.formBuilder.group({
  //     email: [
  //       "",
  //       [
  //         Validators.required,
  //         Validators.pattern(
  //           "^[a-zA-Z0-9_._%+-]+@[a-zA-Z0-9_.-]+\\.[a-zA-Z]{2,5}$"
  //         ),
  //         Validators.maxLength(100),
  //       ],
  //     ]
  //   })
  // }

  ngOnInit() {
    this.getCurrentYear();
    this.initializeForm();
    // this.formControl();
  }

  initializeForm() {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      phone: [''], 
      message2: [''],
    });
  }

  onSubmit() {
    if (this.contactForm.valid) {
      this.sendContactDetails();
    } else {
      this.snackbar.openSnackBar(this._i18nDynamicTranslate.transform("Please fill in all required fields correctly", ['STATIC_PAGE']), 2000);
    }
  }

  sendContactDetails() {
    const formData = {
      name: this.contactForm.value.name,
      email: this.contactForm.value.email,
      phoneNumber: this.contactForm.value.phone.length === 0 ? null : this.contactForm.value.phone,
      message: this.contactForm.value.message2.length === 0 ? null : this.contactForm.value.message2,
    };

    this.apiCall.sendContactDetails(formData).subscribe(
      (response) => {
        const statusCode = response["status"];
        console.log("Status Code:", response);
        if (response["message"] === 'SUCCESS') {
          this.snackbar.openSnackBar(this._i18nDynamicTranslate.transform("Message sent successfully!", ['STATIC_PAGE']), 2000);
          this.contactForm.reset();
        } else {
          this.snackbar.openSnackBar(this._i18nDynamicTranslate.transform("Failed to send message. Please try again later", ['STATIC_PAGE']), 2000);
        }
      },
      (error) => {
        console.error("Error:", error);
        this.snackbar.openSnackBar(this._i18nDynamicTranslate.transform("Failed to send message. Please try again later", ['STATIC_PAGE']), 2000);
      }
    );
  }


  handleNewsLetterFailure(message){
    this.errorMessage = message;
    try {
      setTimeout(() => {
        this.errorMessage = "";
      }, 4000);
    } catch (error) {}
  }

  handleNewsLetterSuccess(status){
    if(status==="Already Subscribed"){
      this.alreadySubscribed = true;
      this.successMessage = this._i18nDynamicTranslate.transform("Already subscribed to our newsletter using this mail ID", ['STATIC_PAGE'])

    }
    else{
      this.subscibeSuccess = true;
      this.successMessage = status;
    }
    this.disableInput = true;
    this.newsLetterForm.patchValue({
      'email': ""
    })
    try {
      setTimeout(() => {
        this.alreadySubscribed=false;
        this.subscibeSuccess = false;
        this.successMessage = "";
      }, 4000);
    } catch (error) {}
  }

  subscribeNewsLetter(){
    if(this.newsLetterForm.valid && 
      !(this.subscibeSuccess || this.alreadySubscribed || this.errorMessage || this.apiLoading || this.disableInput)){
      let email = this.newsLetterForm.value.email;
      this.apiLoading = true;
      this.apiCall.signupForNewsLetter(email).subscribe(response=>{
        let status = response["message"];
        if(status==="success"){
          let result = response["body"];
          this.handleNewsLetterSuccess(result);
        }
        else this.handleNewsLetterFailure(response["body"]);
        this.apiLoading = false;
      },(error)=>{
        let errorText=error.error['body'];
        this.apiLoading = false;
        this.handleNewsLetterFailure(errorText);
      });
    }
    else if(!this.newsLetterForm.valid && !this.disableInput) this.invalidEmail = true;
  }

  // formFocused(){
  //   this.invalidEmail = false;
  //   this.errorMessage = "";
  //   this.successMessage = "";
  //   this.alreadySubscribed = false;
  //   this.subscibeSuccess = false;
  // }
}
